<template>
  <div class="section">
    <div class="page-box">
        <div class="title-part">阅读的误区</div>
        <div class="content-box-part1">
            <div class="content-title-part1"></div>
            <div class="content-inside">
                <div class="content-inside-item">
                    <div>
                        <span class="blue-dot" style="color: #a78bfb">·</span>
                        <span class="content-sub-title-part1"
                            style="color: #a78bfb; font-weight: 600">误区一：</span><span style="color: #fff">阅读多少，就能记多少</span>
                    </div>
                    <div class="first-content">
                        人脑就是信息储存器，可以无限存储。
                    </div>
                </div>
                <div class="content-inside-item">
                    <div>
                        <span class="blue-dot" style="color: #a78bfb">·</span>
                        <span class="content-sub-title-part1"
                            style="color: #a78bfb; font-weight: 600">误区三：</span><span style="color: #fff">阅读就是按文章顺序逐字“扫描”的过程</span>
                    </div>
                    <div class="first-content">
                        按照作者的行文逻辑，从头读到尾，才能完整理解作者意图。
                    </div>
                </div>
                <div class="content-inside-item">
                    <div>
                        <span class="blue-dot" style="color: #a78bfb">·</span>
                        <span class="content-sub-title-part1"
                            style="color: #a78bfb; font-weight: 600">误区二：</span><span style="color: #fff">眼睛“扫”得快，阅读就快</span>
                    </div>
                    <div class="first-content">
                        只要刻意练习，阅读速度就能提高，甚至“一目十行”。
                    </div>
                </div>
                <div class="content-inside-item">
                    <div>
                        <span class="blue-dot" style="color: #a78bfb">·</span>
                        <span class="content-sub-title-part1" style="color: #a78bfb; font-weight: 600">误区四：
                        </span>
                        <span style="color: #fff">作者天然正确</span>
                    </div>
                    <div class="first-content width">
                        预设作者的观点天然正确，不主动甄别，难以形成独立思考能力。
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
.content-box-part1{
  margin-top: 80px!important;
}

.content-inside{
  flex-wrap: wrap;
  width: 500px;
  margin: 50px auto;
  .content-inside-item{
    text-align: left;
    margin-top: 10px;
  }
}
.first-content{
  color: #68696a;
  font-weight: 600;
  font-size: 17px;
  margin-top: 5px;
}
.title-part {
  color: white;
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  margin-top: 5%;
}

.blue-dot {
  color: #40dbff;
  margin-right: 17px;
}
@media only screen and (max-width: 420px) {
  .content-inside{
    width: 90%;
  }
}
</style>
